import axiosInstance from './axiosInstance';

const BASE = '/coding-tracker';

// ─── Students ─────────────────────────────────────────────────────────────────
export const getStudentsByBatch = (batchId) =>
  axiosInstance.get(`${BASE}/batches/${batchId}/students`);

export const getStudentById = (studentId) =>
  axiosInstance.get(`${BASE}/students/${studentId}`);

export const createStudent = (data) =>
  axiosInstance.post(`${BASE}/students`, data);
// body: { batchId, email, leetcodeUsername } — API also accepts legacy key leetCodeUsername

export const addStudentToBatch = (batchId, data) =>
  axiosInstance.post(`${BASE}/batches/${batchId}/students`, data);
// body: { email, leetcodeUsername } — API also accepts legacy key leetCodeUsername

export const deleteStudent = (studentId) =>
  axiosInstance.delete(`${BASE}/students/${studentId}`);

export const bulkAddStudents = (batchId, students) =>
  axiosInstance.post(`/coding-tracker/batches/${batchId}/students/bulk`, { students });

export const updateStudent = (batchId, studentId, data) =>
  axiosInstance.put(`${BASE}/batches/${batchId}/students/${studentId}`, data);


// Legacy aliases
export const fetchStudents  = getStudentsByBatch;
export const addStudent     = addStudentToBatch;
